import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';

interface FoundExpertsProps {
    expertsFound: number;
    total: number;
}

export const FoundExperts: React.FC<FoundExpertsProps> = ({ expertsFound, total }) => (
    <Typography
        marginBottom={{
            default: '4',
            sm: '4',
            md: '6',
            lg: '6',
            xl: '6',
        }}
        color="grey_900"
    >
        <I18n k="skill_page_perseus.experts_found" params={{ expertsFound, total }} />
    </Typography>
);
